import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, MapPin, Quote, Star } from 'lucide-react';
import { testimonials, socialProofAvatars } from '../data/testimonials';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-1 ${className}`} aria-label="5 de 5 estrellas" data-id="element-75" data-mp="3b146nhllnt7f">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className="h-4 w-4 fill-[#F5A524] text-[#F5A524]" aria-hidden="true" data-id="element-76" data-mp="370k9ie110pla" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const active = testimonials[index];
  const go = (dir: number) => {
    setDirection(dir);
    setIndex(prev => (prev + dir + testimonials.length) % testimonials.length);
  };
  return <section className="w-full bg-[#0B2B33] font-heading" aria-labelledby="testimonials-title" data-id="element-77" data-mp="v72hdl3aj2kr">
      {/* Social proof bar */}
      <div className="w-full bg-[#04161C]" data-id="element-78" data-mp="h5eyxl97hv0o">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center gap-4 px-6 py-6 sm:flex-row sm:justify-center sm:gap-8 lg:px-10" data-id="element-79" data-mp="h4n3qbjitzax">
          <div className="flex -space-x-3" data-id="element-80" data-mp="780j9nv3xa9f">
            {socialProofAvatars.map((src, i) => <img key={src} src={src} alt="" aria-hidden="true" className="h-11 w-11 rounded-full border-2 border-[#04161C] object-cover" style={{
            zIndex: socialProofAvatars.length - i
          }} data-id="element-81" data-mp="c6llfstx640i" data-mpi={i} />)}
          </div>
          <div className="text-center sm:text-left" data-id="element-82" data-mp="q5lah1lcgkx7">
            <div className="flex items-center justify-center gap-2 sm:justify-start" data-id="element-83" data-mp="q4s9kh92gpmz">
              <Stars data-id="element-84" data-mp="v3mqterdy64z" />
              <span className="text-sm font-bold text-white" data-id="element-85" data-mp="1iva9j9ehuaw6">4.9/5</span>
            </div>
            <p className="mt-1 text-sm text-white/80" data-id="element-86" data-mp="1ith6s5704atg">
              <span className="mr-1.5 text-[10px] font-bold uppercase tracking-wider text-white/50" data-id="element-87" data-mp="1nmsd857wipku">AR</span>
              +500 profes de Argentina confían en{' '}
              <span className="font-semibold text-[#2DD4C8]" data-id="element-88" data-mp="1sieb945balrf">Stretching Resuelto</span>
            </p>
          </div>
        </div>
      </div>

      {/* Section body */}
      <div className="mx-auto max-w-[1200px] px-6 py-16 lg:px-10 lg:py-20" data-id="element-89" data-mp="1oj5ia1i3irwx">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-90" data-mp="1jhpzkg3e4xhp">
          <div data-id="element-91" data-mp="1ekpp7szid8ks">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#2DD4C8]" data-id="element-92" data-mp="1ekg1kc1xrdi9">
              Validado por profes
            </p>
            <h2 id="testimonials-title" className="mt-3 text-3xl font-bold tracking-[-0.02em] text-white sm:text-4xl lg:text-[2.75rem]" data-id="element-93" data-mp="14stpkdhrxaeg">
              Lo que cambia cuando tenés un sistema
            </h2>
          </div>

          <div className="flex items-center gap-3" data-id="element-94" data-mp="vuq23bn8a3k0">
            <button type="button" onClick={() => go(-1)} aria-label="Testimonio anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/80 transition-colors hover:border-[#2DD4C8]/60 hover:text-[#2DD4C8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2DD4C8]" data-id="element-95" data-mp="qulmroy23evd">
              <ChevronLeft className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="3gfnh1ydgfryz" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Testimonio siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/80 transition-colors hover:border-[#2DD4C8]/60 hover:text-[#2DD4C8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2DD4C8]" data-id="element-97" data-mp="2jr7en1p8xo4g">
              <ChevronRight className="h-5 w-5" aria-hidden="true" data-id="element-98" data-mp="210q2a7oq1559" />
            </button>
          </div>
        </div>

        {/* Card */}
        <div className="relative mt-8 overflow-hidden rounded-3xl border border-[#2DD4C8]/25 bg-[#0A2731] p-7 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.8)] sm:p-10" aria-live="polite" data-id="element-99" data-mp="24zp3pib8ujry">
          <Quote className="pointer-events-none absolute right-7 top-7 h-12 w-12 rotate-180 text-white/[0.06]" aria-hidden="true" data-id="element-100" data-mp="1gvpig3wc85fj" />

          <AnimatePresence mode="wait" initial={false} custom={direction} data-id="element-101" data-mp="1qv7ywad1h92u">
            <motion.blockquote key={active.id} custom={direction} initial={{
            opacity: 0,
            x: direction * 32
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -32
          }} transition={{
            duration: 0.3,
            ease: 'easeOut'
          }} className="relative" data-id="element-102" data-mp="24mlghirdzwv8">
              <Stars data-id="element-103" data-mp="29kn1484go48t" />

              <p className="mt-5 max-w-3xl text-lg italic leading-relaxed text-white/90 sm:text-xl" data-id="element-104" data-mp="k71c44tzi6ly">
                “{active.quote}”
              </p>

              <footer className="mt-8 flex items-center gap-4" data-id="element-105" data-mp="faavnge9p900">
                <img src={active.photo} alt={`Foto de ${active.name}`} className="h-14 w-14 rounded-full border border-[#2DD4C8]/40 object-cover" data-id="element-106" data-mp="2qwuxjestflfd" />
                <div data-id="element-107" data-mp="2h5h3hmjmvdtm">
                  <p className="text-[15px] font-semibold text-white" data-id="element-108" data-mp="2h3w6zrdrdkt4">{active.name}</p>
                  <p className="mt-0.5 flex flex-wrap items-center gap-1.5 text-[13px] text-[#2DD4C8]/85" data-id="element-109" data-mp="2m38v0fgd8xxa">
                    <MapPin className="h-3.5 w-3.5" aria-hidden="true" data-id="element-110" data-mp="287evuo5e9mxd" />
                    {active.city} <span className="text-white/25" data-id="element-111" data-mp="2c8gtj0jnxqx8">•</span> {active.role}
                  </p>
                </div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        {/* Dots */}
        <div className="mt-7 flex items-center justify-center gap-2.5" data-id="element-112" data-mp="3sl5r8g4pogvh">
          {testimonials.map((t, i) => <button key={t.id} type="button" onClick={() => {
          setDirection(i > index ? 1 : -1);
          setIndex(i);
        }} aria-label={`Ver testimonio ${i + 1}`} aria-current={i === index} className={`h-2 rounded-full transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2DD4C8] ${i === index ? 'w-8 bg-[#2DD4C8]' : 'w-2 bg-white/25 hover:bg-white/40'}`} data-id="element-113" data-mp="1em5w71918ix" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}